const ContractStatusTypes = {
    active: 1,
    closed: 2,
} as const;

const ContractAutoPayStatus = {
    pending: 0,
    processed: 1,
    cancelled: 2,
};

const PaymentPlatformTypes = {
    aspire: 1,
    stripe: 2,
} as const;

const PaymentStatusTypes = {
    pending: 0,
    processed: 1,
    cancelled: 2,
    failed: 3,
    disputed: 4,
} as const;

const ElloaiPaymentStatusTypes = {
    todo: 0,
    confirmed: 1,
    cancelled: 2,
    failed: 3,
    disputed: 4,
} as const;

const ElloaiRequestTypes = {
    directPayment: 0,
    reminderMail: 1,
    paymentMail: 2,
} as const;

export {
    ContractStatusTypes,
    PaymentPlatformTypes,
    PaymentStatusTypes,
    ContractAutoPayStatus,
    ElloaiPaymentStatusTypes,
    ElloaiRequestTypes,
};
